export const alertWrapperBase = {
  display: "flex",
  gap: "15px",
  alignItems: "center",
  backgroundColor: "var(--color-light-gray)",
  padding: "15px",
  borderRadius: "var(--border-radius-medium)",
} as const;
